import { ApiError } from '@/lib/api';

/** One sentence for every state that blocks a switch, in the chip tooltip and the toast. */
export const MODEL_SWITCH_UNAVAILABLE = "You can't switch the model right now.";

/** A switch refused because of the model picked, not the run's state. */
export const MODEL_UNAVAILABLE_FOR_RUN = "That model isn't available for this run.";

const MODEL_REFUSAL_CODES: ReadonlySet<string> = new Set([
  'model_not_reachable_for_run',
  'model_not_allowed',
  'model_not_in_catalog',
  'model_command_usage',
]);

/** Copy for a failed switch from the chip or a typed `/model`. Never shows server text. */
export function modelSwitchErrorMessage(err: unknown): string {
  const code = err instanceof ApiError ? (err.code ?? err.message) : undefined;
  return code && MODEL_REFUSAL_CODES.has(code)
    ? MODEL_UNAVAILABLE_FOR_RUN
    : MODEL_SWITCH_UNAVAILABLE;
}
